import { useQuery } from "@tanstack/react-query";
import { api } from "@/api/client";
import type { LocationAutocompleteResponse } from "@/api/types";

type LocationAutocompleteKind = "place" | "address";

export function useLocationAutocomplete(
  query: string,
  kind: LocationAutocompleteKind = "place",
  enabled = true,
) {
  return useQuery({
    queryKey: ["locations", "autocomplete", kind, query],
    queryFn: ({ signal }) =>
      api
        .get("locations/autocomplete", {
          searchParams: kind === "address" ? { q: query, kind } : { q: query },
          signal,
          retry: 0,
        })
        .json<LocationAutocompleteResponse>(),
    enabled: enabled && query.length >= 2,
    retry: false,
    staleTime: 60_000,
  });
}
